<form *ngIf="addressForm" [formGroup]="addressForm | async" (ngSubmit)="updateAddress()">
  <h6>Street</h6>
  <ion-item lines="none" class="cus-input">
    <ion-input formControlName="street" type="text"></ion-input>
  </ion-item>

  <h6>Number</h6>
  <ion-item lines="none" class="cus-input">
    <ion-input formControlName="number" type="text"></ion-input>
  </ion-item>

  <h6>City</h6>
  <ion-item lines="none" class="cus-input">
    <ion-input formControlName="city" type="text"></ion-input>
  </ion-item>

  <h6>Country</h6>
  <ion-item lines="none" class="cus-input">
    <ion-input formControlName="country" type="text"></ion-input>
  </ion-item>

  <h6>ZIP</h6>
  <ion-item lines="none" class="cus-input">
    <ion-input formControlName="zip_code" type="text"></ion-input>
  </ion-item>
</form>
